module.exports = "/packs/edit-gray-4f6e485be47c7ba34c619d4525925db1.svg";